"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    id: {
      required: true,
      type: String
    },

    label: {
      required: true,
      type: String
    },

    name: {
      required: true,
      type: String
    },

    value: {
      default: false,
      type: Boolean
    }
  }
};